'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  ALL: null,
  HOMEPAGE: null,
  ABOUT_US: null,
  CONTACT_US: null,
  TEAM_MEMBERS: null,
  TESTIMONIALS: null,
  RESOURCES: null,
  THANK_YOU: null,
  INVITATION: null,
  FAQ: null,
  EVENT: null,
  COMING_SOON: null,
  SINGLE_PRODUCT: null,
  MULTI_PRODUCT: null,
  PRICING: null,
  MAINTENANCE: null,
  HOLIDAY: null,
  SERVICES: null,
  CASE_STUDY: null,
  OFFER: null,
  NEWSLETTER: null,
  E_BOOK: null,
  PILLAR: null
});